import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const LinkBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.LINK}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.LINK)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.LINK)} alt="link" />
    </Box>
  );
};
